let React = require("react");

let Toast = require("../../Toast.jsx");

let ContentServerClient =  require("../../../ContentServerClient.js");

class TransferOwnershipToastHub extends React.Component {

    constructor(){
        super();

        this.state = {transfers: []}
        this.requestError = false
    }

    componentDidMount(){
        this.getListTransfersTo();
    }

    acceptTransferHub(transferId, hub_id){
        const {setLoading, handleError, checkHubsAvailability, history} = this.props;

        checkHubsAvailability(({ premiumError, subscribeError } = {}) => {
            setLoading(true, "Accepting...");

            async function handleSearchOriginError(response, intent) {
                const res = await response.json();
                const message = res ? res.error.message : "";
                setLoading(false);
                if (message === 'You can only create 1 hubs.') return subscribeError();
                if (message === 'You can only create 16 hubs.') return premiumError();
                return handleError(response, intent);
            }
            const errorHandler = premiumError && subscribeError ? handleSearchOriginError : handleError;

            ContentServerClient.acceptTransferHub(errorHandler, {transferId})
                .then(() => {
                    setLoading(false);
                    this.getListTransfersTo();
                    history.push(`/hubs/${hub_id}-Loading/libraries`);
                })
                .catch(() => {
                    setLoading(false);
                    this.getListTransfersTo();
                })
        })
    }

    rejectTransferHub(transferId){
        const {setLoading, handleError} = this.props;
        setLoading(true, "Rejecting...");

        ContentServerClient.rejectTransferHub(handleError, {transferId})
        .then(() => {
            setLoading(false);
            this.getListTransfersTo();
        })
        .catch(() => {setLoading(false); this.getListTransfersTo()})
    }

    getListTransfersTo(){
        // dont throw errors from toasts
        ContentServerClient.getListTransfersTo(()=>{})// this.props.handleError
        .then((data) => {
            let {transfers} = data;
            this.setState({transfers})
        })
        .catch(() => {this.props.setLoading(false)})
    }

    render() {
        const {transfers} = this.state;

        return  <Toast resizeToastContainer={this.props.resizeToastContainer} show={transfers.length > 0} toastName="transfer" type="invitation" hasClose={false}>
                    {transfers.map(({id:transferId, hub:{name:hubName, id:hub_id}, from: {name}}) =>
                        <div className="contTransfer" key={transferId}>
                            <p className="text"><span className="bold">{name}</span> would like to transfer ownership of the {hubAlias} <span className="bold">{hubName}</span> to you. Do you accept?</p>
                            <div className="contOptions">
                                <button className="button" onClick={() => this.acceptTransferHub(transferId, hub_id)}>Yes</button>
                                <button className="button transparent" onClick={() => this.rejectTransferHub(transferId)}>No</button>
                            </div>
                        </div>
                    )}
                </Toast>
    }
}

module.exports = TransferOwnershipToastHub;
